/* @generated */

// src/assets/ui-icon/line/slides.tsx
import * as React from "react";
var SlidesLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M14.25 8.202h1.5v5.596h-1.5V8.202Zm-1.5 1.17h-1.5v4.426h1.5V9.372Zm-3 1.171h-1.5v3.255h1.5v-3.255Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 4.5h18.5V6h-1v9.25A2.25 2.25 0 0 1 18 17.5h-2.833l1.025 2.462L16.1 20h-1.518l-1.041-2.5H9.958L8.916 20H7.4l-.093-.038L8.334 17.5H6a2.25 2.25 0 0 1-2.25-2.25V6h-1V4.5Zm15.78 11.28a.75.75 0 0 0 .22-.53V6H5.25v9.25A.75.75 0 0 0 6 16h12a.75.75 0 0 0 .53-.22Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  SlidesLine
};
